import React from 'react';
import { Input as MuiInput } from '@mui/material';

const Input = props => <MuiInput {...props} />;

export default Input;
